import connectFormikField from '../connectFormikField/connectFormikField'
import Input from '@/redesign/components/Input/Input'

const FormikInput = connectFormikField(Input)

export default FormikInput
